import * as React from 'react'
import {Component} from 'react'
import {Link} from 'react-router-dom'
import Content from '../../Components/Content'

import Utils from '../../lib/Utils'
import './Battle.css'

class Battle extends Component {
  public componentDidMount() {
    document.title = '联机对战 - 现场活动 - 彩虹火箭队基地'
    Utils.setAppClass('app-battle')
  }

  public render() {
    return (<div className="battle-container">
      <Content className="battle-content" contentClassName="battle-content-content" onLeft={false}
               contentTitle={<span><strong>联机</strong><br/>对战</span>}>
        <h1>【参赛方式】</h1>
        <p>**本次比赛全程不设参赛费<br/>
          **参与现场赛需要通过预选赛获得参赛权，具体参照后详</p>
        <h2>*关于预选赛</h2>
        <p>预选赛以PGL伙伴大会的形式，目前正在进行中。</p>
        <p>更多详情可参考<a href="http://weibo.com/ttarticle/p/show?id=2309404210350907102707" target="_blank">线上赛详细规则</a>。
        </p>
        <h2>*关于PMO当日现场赛参赛权（本项内容与上述链接中有部分偏差，以此页为准）</h2>
        <ol>
          <li>前一届魔都PMO对战区冠军</li>
          <li>与魔都PMO有联动的2018年内各种WCS2018规则的线上或上海地区线下比赛冠军（杰哥杯、魔都精灵宝可梦月赛、菇吧赛、E cup、yf杯等等，具体会由主办直接联系比赛冠军确定是否能参赛）</li>
          <li>每场线上赛单场最高得分者（未完成线上预赛规则第【四】条的报名条件的训练家以及已经通过1、2获得参赛权的训练家不计算在排名内）</li>
          <li>其余训练家按最终得分进行排序，并且由魔都PMO2018当日到场情况，依次填补直至满32人。</li>
        </ol>
        <p>以上逐条已按优先度排序。</p>
        <p>通过1、2、3获得的参赛权将于8月上旬进行最终确认，若无法参与魔都PMO将在同个比赛中按成绩顺延到亚军，若亚军依然无法参与则参赛权作废。</p>
        <p>若有训练家通过1、2、3获得多个参赛权，也将于8月上旬进行协调。</p>
        <p>8月上旬也将根据最终得分的排名，对高名次训练家一一确认是否到场参赛。</p>

        <h1>【比赛流程】</h1>
        <p>比赛当日将进行32人的淘汰赛</p>
        <h2>*大致时间安排</h2>
        <ul>
          <li>09:30-09:55——入场&现场登记</li>
          <li>09:55-10:00——截止登记&抽签分组&准备比赛</li>
          <li>10:00-10:35——淘汰赛第一轮</li>
          <li>10:35-11:10——淘汰赛第二轮</li>
          <li>11:10-11:25——休息</li>
          <li>11:25-11:30——准备比赛</li>
          <li>11:30-12:05——淘汰赛第三轮</li>
          <li>12:05-12:40——淘汰赛第四轮</li>
          <li>13:30——决赛（现场直播）</li>
        </ul>
        <p>若所有对局在时间段内提前结束，根据具体时间将可能提前行程。</p>
        <p>若到达时间截点有未完成的对局，将根据后述胜负规则进行判定。</p>
        <h2>*关于入场和现场登记</h2>
        <p>事先有确定参赛权的训练家可在【冠军之路】处通过参赛ID号和门票进行签到和入场。</p>
        <p>未确定参赛权但预赛积分排名前50的训练家，亦可在【冠军之路】处通过参赛ID号和门票进行签到和入场。但最终是否可参赛需要在截止登记后根据现场签到情况决定（届时会有广播通知）</p>
        <p>完成签到并入场的训练家，需要在对战检录处领取队伍登记表并在对战区进行填写，以及扫取现场伙伴大会QR码完成3DS本体的参赛设定。</p>
        <p>填写并提交完队伍登记表的训练家在截止登记前可至展区自由活动，也可在对战区备战。</p>
        <p>在展区自由活动的训练家必须在09:55前返回对战区准备比赛。</p>
        <p>若在截止登记后，比赛人数仍未满足32人，将根据根据积分排名顺序，通过广播招集现场排名靠前的训练家参赛。</p>
        <p>比赛预定时间到达时若仍未满足人数，将以现有人数强制开始比赛，逾期不候。</p>
        <p>到达截止登记时间时，将现场进行抽签决定对战对手和分组。</p>
        <h2>*队伍登记表</h2>
        <p>训练家需要填写队伍登记表的信息。</p>
        <p>队伍登记表原则上需要在截止登记前完成填写，若有未完成填写的，可以在赛间休息时间进行填写。</p>
        <p>比赛当天提交完队伍表后，不得再对精灵进行任何更改。</p>
        <p>填写表格可以使用中文、日文或英文。</p>
        <p>使用中文的场合，请完全使用官方译名。</p>
        <p>使用日文或英文的场合，请完整抄写游戏内原文。</p>
        <h2>*具体赛制</h2>
        <p>采取32人三局两胜的淘汰赛</p>
        <p>所有选手将在比赛开始前进行抽签，决定其对战对手和分组。</p>
        <p>淘汰赛每轮限时35分钟</p>
        <p>最终决赛将进行现场直播</p>

        <h1>【比赛规则】</h1>
        <p>总体规则：VGC2018（即当前究极之日/究极之月排位赛季的WCS模式）</p>
        <p>1. 队伍构成</p>
        <p>1.1 对战箱设置</p>
        <p>训练家的队伍必须放置于对战箱内，由比赛开始至结束将无法作出任何改动。</p>
        <p>队伍必须持有最少4只宝可梦。</p>
        <p>1.2 昵称</p>
        <p>队伍不能持有2只相同昵称的宝可梦。</p>
        <p>队伍不能持有以另一只宝可梦名称作为昵称的宝可梦。</p>
        <p>训练家为角色和宝可梦命名时，必须避免使用含有任何不当、猥亵或其他攻击性内容的词语或字句。</p>
        <p>1.3 道具</p>
        <p>每只宝可梦均可携带一项道具，相同装备道具不能同时使用。</p>
        <p>训练家只可使用从「精灵宝可梦 太阳/月亮/究极之日/究极之月」、「Pokémon Global Link」或官方活动中取得的道具。</p>
        <p>可携带各种超级进化石（mega进化石）和Z纯晶。</p>
        <p>1.4 宝可梦</p>
        <p>训练家队伍不能持有2只或以上全国图鉴编号相同的宝可梦。</p>
        <p>宝可梦只可使用从正常游玩或官方活动中习得的招式。</p>
        <p>可使用隐藏特性的宝可梦。</p>
        <p>所有宝可梦必需附有十字标记以代表该宝可梦从「精灵宝可梦 太阳/月亮/究极之日/究极之月」内获得。</p>
        <p>51或以上等级的宝可梦是允许参赛的，但于比赛中会由系统自动调整至50等级。</p>
        <p>等级50以下的宝可梦是允许参赛的，但也会调整至等级50。</p>
        <p>训练家可以使用全国图鉴编号No.001-807的宝可梦，须为从游戏中捕获，从过去的游戏传送而来，或从官方活动取得的宝可梦。</p>
        <p>禁止使用宝可梦清单：</p>
        <p>超梦、梦幻、洛奇亚、凤王、时拉比、固拉多、盖欧卡、烈空坐、基拉祈、代欧奇希斯、帝牙卢卡、帕路奇亚、骑拉帝纳、霏欧纳、玛纳霏、达克莱伊、谢米、阿尔宙斯、比克提尼、莱西拉姆、捷克罗姆、酋雷姆、凯路迪欧、美罗耶塔、盖诺赛克特、哲尔尼亚斯、伊裴尔塔尔、基格尔德、蒂安希、胡帕、波尔凯尼恩、科斯莫古、科斯莫姆、索尔迦雷欧、露奈雅拉、奈克洛兹马、玛机雅娜、玛夏多、捷拉奥拉、小智版甲贺忍蛙</p>
        <p>2. 设备规则</p>
        <p>2.1 游戏系统</p>
        <p>训练家可使用任何Nintendo 3DS系列主机参赛，训练家有责任准备充足电源，比赛期间因主机电量不足而无法继续作赛者，视为弃权。</p>
        <p>2.2 游戏更新</p>
        <p>训练家必须确认自己的「究极之日/究极之月」游戏版本已更新为最新版本，若训练家于比赛时未能满足游戏版本要求，将有可能受到包括取消资格的处分。</p>
        <p>2.3 使用手机规则</p>
        <p>训练家可使用手机在进行出战宝可梦选择时拍照记录对方队伍全体，但不可在对战中查阅图鉴软件的资料或是上网查阅各种宝可梦相关资料。</p>
        <p>2.4 笔记</p>
        <p>训练家于比赛的任何时间都可以进行笔记，惟必须使用白纸或文稿纸；若纸张上印有标志或文字，则无法使用。</p>
        <p>现场将提供文稿纸供训练家笔记，有需要的训练家可以在裁判处领取。</p>
        <p>2.5 比赛区域内的物品</p>
        <p>训练家可摆放幸运符或物件于比赛区域内，但必须保持范围齐整。训练家必须避免摆放妨碍游戏主机红外线通讯的物品。</p>
        <p>3. 比赛形式与规则</p>
        <p>3.1 Double Battle (ダブルバトル) ---WCS2018</p>
        <p>每位训练家从对战箱选择4只宝可梦进行对战。比赛开始时，训练家先从队伍中派出2只宝可梦出战。对战场上总共会有4只宝可梦。比赛会持续到其中一方全部4只宝可梦无法战斗或限时结束。</p>
        <p>3.2 队伍锁定&伙伴大会</p>
        <p>比赛开始前需将对战精灵存入战斗箱内，比赛开始前会对训练家进行检查，若与所填表格不符将需要更改。</p>
        <p>由于使用线下伙伴大会系统，不请勿解除伙伴大会的参赛状态。</p>
        <p>3.3 比赛判决</p>
        <p>训练家以令对手最后一只宝可梦无法战斗而获胜。</p>
        <p>如果2位训练家的宝可梦在该局最后一回合同时无法战斗，最后无法战斗的宝可梦的训练家将获胜。</p>
        <p>3.3.1 超时</p>
        <p>若限时超过时，其中一方训练家仍然未击倒其对手的宝可梦，该局胜利者将会根据下列规则判定。</p>
        <p>・余下的宝可梦</p>
        <p>如果其中一方训练家余下的宝可梦数目多于对手，则该训练家获胜。</p>
        <p>如果2位训练家余下的宝可梦数目相同，比赛结果将按余下HP的平均百份比判定，如下所述：</p>
        <p>・余下HP的平均百份比如果其中一方训练家的队伍的余下HP的平均百份比较高，则该训练家获胜，计算方法如下：</p>
        <p>(余下宝可梦的目前HP)/(4只出战宝可梦的HP上限)</p>
        <p>如果两位训练家的余下HP的平均百份比相同，比赛结果将按余下HP数值决定，如下所述:</p>
        <p>・余下的HP数值</p>
        <p>如果其中一方训练家的隊伍余下的HP数值较高，则该训练家获胜。</p>
        <p>如果2位训练家的队伍余下的HP数值相同，则该局为平局。</p>
        <p>3.3.2 决胜方法</p>
        <p>淘汰赛采取三局两胜制。</p>
        <p>淘汰赛对战时间最多为一轮35分钟，限时内仍未分出胜负时，将由裁判按座位号顺序开始进行裁决。</p>
        <p>若达到限时时进行的是1回战，则将按3.3.1的规则进行判决后，直接以该场胜负作为比赛结果，判决胜者的训练家晋级。</p>
        <p>若达到限时时进行的是2回战，先按3.3.1的规则进行判决，若判决结果为1回战胜者胜利，则直接判定胜者晋级。若判决结果为1回战败者胜利导致平手时，则将按双方队伍重复度进行判决，重复度低的判胜。*注1</p>
        <p>若达到限时时进行的是3回战，则将按3.3.1的规则进行判决，判决胜者的训练家晋级。</p>
        <p>4. 违规宝可梦</p>
        <p>4.1 违规改造宝可梦</p>
        <p>禁止使用明显的非法宝可梦与道具。</p>
        <p>禁止使用截至比赛当日没有正规获得途径的宝可梦以及其技能。</p>
        <p>禁止其他明显的修改行为。</p>
        <p>一经发现视情况从当轮起本次比赛内所有场次全部判负。</p>
        <p>4.2 人工检测</p>
        <p>比赛开始前工作人员将会对参实者进行宝可梦检查，若发现训练家使用的宝可梦 有经非正常途径入手嫌疑，将会要求更换为数据正常的宝可梦或道具进行参赛。</p>
        <p>比赛期间会对训练家进行抽查，若与所填表格不符将从当轮起全部判负。</p>
        <p>4.3 举报怀疑改造</p>
        <p>比赛过程中，如训练家发现有明显非法精灵或道具时，可在对战结束后保存录像并向裁判进行举报。（现场伙伴大会中可以留下前一场对战的录像）</p>

        <h1>【比赛注意事项】</h1>
        <p>训练家参赛必须持有魔都PMO2018的门票。</p>
        <p>训练家请自备正版「精灵宝可梦 究极之日/究极之月」游戏卡带或下载版软件及符合比赛规则的宝可梦，方可参赛。</p>
        <p>尊重知识产权，不得以非原装正版游戏卡或各种改版下载软件作赛，违者经发现将被取消资格。</p>
        <p>比赛时间以现场显示时间为准。</p>
        <p>比赛后请将桌上的纸张交予比赛工作人员。</p>
        <p>训练家有责任准备充足电源，比赛期间因主机电量不足而无法继续作赛者，视为弃权。*注2</p>
        <p>任何引致妨碍比赛整体运作的行为，或是妨碍魔都PMO2018活动的行为，经过工作人员判断后，有权判决生事者取消资格。</p>
        <p>若有任何争议，魔都PMO组委会保留最终决定权。</p>

        <h1>【比赛奖品】</h1>
        <Link to="/prize">点我查看</Link>

        <h2>备注内容</h2>
        <p>注1：队伍重复度=训练家的六只精灵在该次比赛中总使用数的总和。</p>
        <p>【例】训练家A的队伍为：炽焰咆哮虎、卡璞·鳍鳍、卡璞·蝶蝶、巨金怪、班基拉斯、闪电鸟，而统计出的所有参赛训练家中，这6只精灵的使用数分别为18、16、15、15、12、10的话，那么这位训练家的队伍重复度即为18+16+15+15+12+10=86</p>
        <p>另，相同编号的精灵的各种形态记为同个精灵的使用数。</p>
        <p>若双方队伍重复度依然相同的场合，则将以预选赛时的最终得分为胜负判定依据，最终得分较高者获胜。（该项判定将无视通过其他方式获得的参赛权，只看5场预选赛中最高得分的2场的总分）</p>
        <p>注2：会场会设置少量充电设备，可以给训练家进行充电帮助。但是数量有限，请尽可能保证充足电源或携带虫电宝。</p>
      </Content>
      <div className="background-characters battle-characters"/>
    </div>)
  }
}

export default Battle



// WEBPACK FOOTER //
// ./src/Views/Events/Battle.tsx